import cleanedFilename from '~/util/cleanedFilename';

export default {
  DUE_DATE_INFORMATION: `${cleanedFilename(__filename)}-due-date-information`,
  TASK_ASSIGNED_USER: `${cleanedFilename(__filename)}-task-assigned-user`,
  TASK_ASSIGNED_OFFICE: `${cleanedFilename(__filename)}-task-assigned-office`,
};
